<section class="app-hom-top">
  <div class="app-hom-top__red-cir" [appAnimate]="'slideInDown'" [speed]="'fast'" [delay]="'300'"></div>
  <picture [appAnimate]="'fadeIn'" [speed]="'fast'">
    <source media="(max-width:550px)" srcset="assets/images/pages/home/top-banner-mb.webp" />
    <source media="(max-width:991px)" srcset="assets/images/pages/home/top-banner-mb@2x.webp" />
    <source media="(max-width:1366px)" srcset="assets/images/pages/home/top-banner.webp" />
    <img
      class="app-hom-top__bg"
      [priority]="true"
      alt="background"
      ngSrc="assets/images/pages/home/top-banner@2x.webp"
      [fill]="true"
    />
  </picture>

  <div class="app-hom-top__con" [appAnimate]="'slideInLeft'" [speed]="'fast'">
    <img
      ngSrc="assets/images/pro-connect-white.svg"
      [priority]="false"
      alt="logo"
      height="27"
      width="271"
      class="app-hom-top__con__log d-none d-md-block"
    />
    <img
      ngSrc="assets/images/pro-connect-black.svg"
      [priority]="false"
      alt="logo"
      height="27"
      width="271"
      class="app-hom-top__con__log d-block d-md-none"
    />
    <p class="app-hom-top__con__p">
      W PRO.CONNECT pasja spotyka się z biznesem. <br class="d-none d--md-inline" />
      Rozwijaj swoje umiejętności, inspiruj się trendami<br class="d-none d--md-inline" />
      i buduj silną markę wraz z L'Oréal. Dołącz do<br class="d-none d--md-inline" />
      społeczności PRO.CONNECT i zyskaj:
    </p>
    <ul class="app-hom-top__con__ul">
      <li>Wiedzę ekspertów z różnych branż.</li>
      <li>Dostęp do innowacyjnych narzędzi i rozwiązań.</li>
      <li>Wsparcie w rozwoju Twojego salonu.</li>
      <li>Możliwość networkingu z najlepszymi.</li>
    </ul>
    @if (!user()) {
      <a
        [routerLink]="['/' + WwwRouteSlug.LOGIN]"
        class="www-btn www-yellow-btn app-hom-top__con__btn"
        appGtmClick
        [layer]="{
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'home page',
          eventAction: 'select::join pro connect',
          eventLabel:
            'go to login page::' +
            '/' +
            (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE : '/' + WwwRouteSlug.PRO_EXPERIENCE),
          event_name: 'body_button_click',
          module_name: 'join pro connect',
          cta_name: 'go to login page',
          link_url:
            '/' +
            (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE : '/' + WwwRouteSlug.PRO_EXPERIENCE),
        }"
        >Dołącz do PRO.CONNECT i rozwiń swój salon!</a
      >
    }
  </div>
</section>
